/* tslint:disable */
import {
  StockWarehouse
} from '../index';

declare var Object: any;
export interface StockWarehouseLocationInterface {
  "id"?: number;
  "name": string;
  "warehouse_id"?: number;
  warehouse?: StockWarehouse;
}

export class StockWarehouseLocation implements StockWarehouseLocationInterface {
  "id": number;
  "name": string;
  "warehouse_id": number;
  warehouse: StockWarehouse;
  constructor(data?: StockWarehouseLocationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StockWarehouseLocation`.
   */
  public static getModelName() {
    return "StockWarehouseLocation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StockWarehouseLocation for dynamic purposes.
  **/
  public static factory(data: StockWarehouseLocationInterface): StockWarehouseLocation{
    return new StockWarehouseLocation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StockWarehouseLocation',
      plural: 'StockWarehouseLocations',
      path: 'StockWarehouseLocations',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "warehouse_id": {
          name: 'warehouse_id',
          type: 'number'
        },
      },
      relations: {
        warehouse: {
          name: 'warehouse',
          type: 'StockWarehouse',
          model: 'StockWarehouse',
          relationType: 'belongsTo',
                  keyFrom: 'warehouse_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/StockWarehouseLocation.ts